export default __webpack_public_path__ + "static/media/craon32.448cd21c.jpg";